var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"disable-sort":"","headers":_vm.headers,"items":_vm.faultData,"items-per-page":5,"hide-default-footer":"","no-data-text":"没有设备故障","loading-text":"数据加载中...","dark":_vm.theme.tableDark}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }